import DemoWrapper from "../../utils/DemoPageWrapper";
/* eslint-disable import/no-webpack-loader-syntax */
import Demo from "./demo";
import DemoSource from "!!raw-loader!./demo.vue";

const config = {
  props: [
    {
      prop: "value",
      description: "绑定的值"
    },
    {
      prop: "border",
      description: "是否显示边框",
      type: "Boolean",
      default: "false"
    },
    {
      prop: "size",
      description: "大小 mini/small/default/middle/large",
      type: "String",
      default: "default"
    },
    {
      prop: "padding",
      description: "左右padding",
      type: "Number"
    },
    {
      prop: "dark",
      description: "是否为dark模式",
      type: "Boolean",
      default: "false"
    },
    {
      prop: "textArea",
      description: "是否为textarea",
      type: "Boolean",
      default: "false"
    },
    {
      prop: "readonly",
      description: "readonly",
      type: "Boolean",
      default: "false"
    },
    {
      prop: "disabled",
      description: "是否禁用",
      type: "Boolean",
      default: "false"
    },
    {
      prop: "cursor",
      description: "鼠标样式",
      type: "String",
      default: "text"
    },
    {
      prop: "type",
      description: "input类型 text/file",
      type: "String",
      default: "text"
    },
    {
      prop: "isFocus",
      description: "input是否为高亮样式（蓝色选中态）",
      type: "Boolean",
      default: "false"
    },
    {
      prop: "isError",
      description: "input是否为error样式（红色报错）",
      type: "Boolean",
      default: "false"
    }
  ],
  events: [],
  methods: [],
  slots: []
};

export default DemoWrapper(Demo, DemoSource, config);
